module.exports = __webpack_public_path__ + "img/375.a6218d77.jpg";